import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { Card, Image, Divider } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import Logo from '../../images/logo-admin.png'
// import { history } from '../store'
import { Text, LanguageContext } from '../../helpers/language';

const Maintenance = (props) => {
  const languageContext = useContext(LanguageContext);
    
  return (
      <div className="login animated fadeIn" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh'
      }}>
        <Row style={{ width: '100%' }}>
          <Col xs={12}>
            <Row center="xs">
              <Col xs={11} sm={10} md={8} lg={5}>
                <Card fluid={true} raised={true} centered={true}>
                  <Card.Content>                    
                    <div className="loginForm" style={{ textAlign: 'center' }}>                    
                      <Image size='small' src={ Logo } className='m-b-50'/>
                      <div style={{ wordBreak: 'break-word' }}>   
                        Sito in Manutenzione, riprova tra qualche minuto!                  
                        <Divider />
                        <div className="footer">
                          <Link to="/login">
                            <Text tid="back_to_login" />
                          </Link>                          
                        </div>
                      </div>
                    </div>
                  </Card.Content>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
  )
}

Maintenance.propTypes = {
  auth: PropTypes.object
}

const mapStateToProps = (state) => ({
  auth: state.auth,
})

export default connect(mapStateToProps)(Maintenance)
